module.exports = __webpack_public_path__ + "static/media/tenable_sc_logo.56985821.svg";